import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../../../../../@casino/ui/table';
import { setGetMailingStatisticsScrollerOpenGameByUser } from '../../../../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerOpenGameByUser';
import { format } from 'date-fns';
import { setGetMailingStatisticsScrollerOpenGameByUserAction } from '../../../../../../../../store/mailing/action';
import { setGetMailingStatisticsScrollerUsersDepositsByUser } from '../../../../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersDepositsByUser';

const ScrollerOpenGame = ({
    login,
    mailing_id
}) => {
    const dispatch = useDispatch();
    const details = useSelector((state) => state.mailing.scrollers.deposits_by_user)


    const columns = [
        { id: 'data', label: 'Дата депозита'},
        { id: 'amount', label: 'Сумма'},
        { id: 'currency', label: 'Валюта'},
        { id: 'pay', label:  'Платежная система'},
        { id: 'status', label: 'Статус'}
    ];

    const handleChange = ({
        page,
        pageSize
    }) => {
        dispatch(setGetMailingStatisticsScrollerUsersDepositsByUser({
            mailing_id, 
            login, 
            page,
            pageSize
        }))
    }

    return (
        <div style={{width: '100%', margin: '10px 0 20px'}}>
            <TableCasino
                width={"100%"}
                pagination
                allPage={details?.[login]?.totalPage || 1}
                perPage={details?.[login]?.pageSize || 25}
                columns={columns}
                rows={details?.[login]?.list?.map((item) => ({
                    ...item,
                    data: format(new Date(Number(item.data)), 'dd.MM.yyyy HH:mm'),
                    status: item.status === 'ready_for_pay' ? 'Не оплачен' : item.status === 'paid' ? 'Оплачен' : 'Неизвестно',
                    amount: new Intl.NumberFormat('ru-RU').format(item.amount)
                })) || []}
                changePage={(v) => {
                    handleChange({
                        page: v.page + 1,
                        pageSize: v.rowsPerPage
                    })
                }}
                changeRowsPerPage={handleChange}
            />
        </div>
    )
}

export default ScrollerOpenGame;